// Module 5 / Slice 5 — Rota detail Assignments tab.
//
// Lists rota_employee_assignment rows for the current rota ordered by
// effectiveFrom. The `is_primary` toggle UX + the GIST-overlap explainer
// modal are deferred to a follow-up SPA hardening commit (carry
// C-mod5-empref + C-mod5-10); v1 ships the read surface with
// data-testids hooked for Playwright assertions.

import type { components } from "../../../api/rota-config.gen";
import { useI18n } from "../../../i18n/I18nContext";

type RotaAssignment = components["schemas"]["RotaEmployeeAssignment"];

export function AssignmentsTab({
  rotaId,
  assignments,
}: {
  rotaId: string;
  assignments: readonly RotaAssignment[];
}): JSX.Element {
  const { t } = useI18n();
  if (assignments.length === 0) {
    return (
      <p data-testid={`assignments-tab-empty-${rotaId}`}>
        {t("rota_config.assignments.empty")}
      </p>
    );
  }
  return (
    <table className="rc-table" data-testid="assignments-tab-table">
      <thead>
        <tr>
          <th>{t("rota_config.assignments.col.employee")}</th>
          <th>{t("rota_config.assignments.col.position")}</th>
          <th>{t("rota_config.assignments.col.effectiveFrom")}</th>
          <th>{t("rota_config.assignments.col.effectiveTo")}</th>
          <th>{t("rota_config.assignments.col.primary")}</th>
        </tr>
      </thead>
      <tbody>
        {assignments.map((a) => (
          <tr key={a.id} data-testid={`assignment-row-${a.id}`}>
            <td data-testid={`assignment-employee-${a.id}`}>{a.employeeId}</td>
            <td>{a.rotaPositionId}</td>
            <td>{a.effectiveFrom}</td>
            <td>{a.effectiveTo ?? "—"}</td>
            <td data-testid={`assignment-primary-${a.id}`}>
              {a.isPrimary ? t("rota_config.assignments.primary.yes") : t("rota_config.assignments.primary.no")}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
